// @ts-nocheck
import './index.css';
import React, { useState } from 'react';
import { render } from 'react-dom';
import { CnDialog, CnInput } from '@alife/cn-ui/dist/cn-ui.js';
import privacyInit from './privacy';
const URLParams = new URLSearchParams(window.location.search);
const appKey = URLParams.get('appKey') || '';
const scene = URLParams.get('scene') || '';
const mode = URLParams.get('mode') || '';
const trans = URLParams.get('trans') || '';
const redirectUrl = URLParams.get('redirectURL') || '';
const needOrder = URLParams.get('needOrder') === 'true';
let orderId = '';
let language = URLParams.get('language') || 'zh';
switch (language.toLowerCase()) {
    case 'zh':
    case 'zh-cn':
    case 'zh-zh':
        language = 'cn';
        break;
    case 'zt':
        language = 'tw';
        break;
    case 'en-us':
    case 'en':
        language = 'en';
        break;
    case 'ru':
    case 'ru-ru':
        language = 'ru';
        break;
    // 法语暂时用英语代替
    case 'fr':
    case 'fr-fr':
        language = 'fr';
        break;
    case 'es':
    case 'es-es':
        language = 'es';
        break;
    case 'pt':
    case 'pt-pt':
        language = 'pt';
        break;
    case 'he':
    case 'iw-IL':
        language = 'he';
        break;
    default:
        language = 'cn';
}
const isRtl = language === 'he';
let langPackMap = {
    ru: {
        'machine-auth-modal-cancel-button': 'Перевод на оператора',
        'machine-auth-modal-order-tital': 'Для оперативной консультации подготовьте и введите трек-номер вашей посылки.',
        'machine-auth-modal-ok-button': 'Нет трек-номера посылки',
        'machine-auth-modal-input-hint': 'Пожалуйста, укажите трек-номер посылки\nТрек-номер, RLxxxxxxxxxxxx',
        'machine-auth-modal-order-type-invalid': 'Текущий номер документа вводится неверно. Проверьте информацию о номере документа и введите его снова',
    },
    tw: {
        'machine-auth-modal-cancel-button': '進入諮詢',
        'machine-auth-modal-order-tital': '請輸入你要諮詢的單號,以便更快為您解答',
        'machine-auth-modal-ok-button': '沒有單號,直接諮詢',
        'machine-auth-modal-input-hint': '請輸入運單號,如JN1234567',
        'machine-auth-modal-order-type-invalid': '當前輸入單號不正確，請核對單號資訊後再次輸入。',
    },
    pl: {
        'machine-auth-modal-cancel-button': 'Wprowadź konsultację',
        'machine-auth-modal-order-tital': 'Wprowadź numer nieparzysty, z którym chcesz się skonsultować, aby móc szybciej odpowiedzieć.',
        'machine-auth-modal-ok-button': 'Brak liczby nieparzystej, bezpośrednie konsultacje',
        'machine-auth-modal-input-hint': 'Wprowadź numer listu przewozowego, na przykład JN1234567',
        'machine-auth-modal-order-type-invalid': 'O número de entrada atual está incorreto. Verifique as informações do número e tente novamente.',
    },
    en: {
        'machine-auth-modal-cancel-button': 'Enter',
        'machine-auth-modal-order-tital': 'Please enter your tracking number to get an answer faster.',
        'machine-auth-modal-ok-button': 'Consult without tracking number',
        'machine-auth-modal-input-hint': 'Please enter the waybill number, such as JN1234567',
        'machine-auth-modal-order-type-invalid': 'The current order number is incorrect. Please verify the order number information and enter it again.',
    },
    tr: {
        'machine-auth-modal-cancel-button': 'Konsültasyona girin',
        'machine-auth-modal-order-tital': 'Lütfen daha hızlı cevap verebilmeniz için danışmak istediğiniz tek numarayı girin.',
        'machine-auth-modal-ok-button': 'Tek numara yok, doğrudan danışmanlık',
        'machine-auth-modal-input-hint': 'Lütfen jn1234567 gibi irsaliye numarasını girin',
        'machine-auth-modal-order-type-invalid': 'Mevcut sipariş numarası yanlış. Lütfen sipariş numarası bilgilerini doğrulayın ve tekrar girin.',
    },
    cn: {
        'machine-auth-modal-cancel-button': '进入咨询',
        'machine-auth-modal-order-tital': '请输入你要咨询的单号，以便更快为您解答',
        'machine-auth-modal-ok-button': '没有单号,直接咨询',
        'machine-auth-modal-input-hint': '请输入要咨询的单号（运单，交易单，LP，LBX都支持）',
        'machine-auth-modal-order-type-invalid': '当前输入单号不正确，请核对单号信息后再次输入',
    },
    es: {
        'machine-auth-modal-cancel-button': 'Entrar',
        'machine-auth-modal-order-tital': 'Por favor inserte el número de seguimiento',
        'machine-auth-modal-ok-button': 'Consultar sin número de seguimiento',
        'machine-auth-modal-input-hint': 'El número de seguimiento normalmente tiene 18 dígitos',
        'machine-auth-modal-order-type-invalid': 'El número de pedido actualmente ingresado es incorrecto. Por favor, verifique la información del número de pedido y vuelva a ingresarlo.',
    },
    fr: {
        'machine-auth-modal-cancel-button': 'Entrer',
        'machine-auth-modal-order-tital': 'Veuillez saisir le numéro de suivi afin que nous puissions vous aider rapidement.',
        'machine-auth-modal-ok-button': "Si vous n'avez pas le numéro de suivi, vous pouvez nous contacter pour vous aider.",
        'machine-auth-modal-input-hint': 'Merci de rajouter le no. de suivi, par exemple DOFR, CNFR, CNG ou par LP',
        'machine-auth-modal-order-type-invalid': 'Le numéro de commande actuellement saisi est incorrect. Veuillez vérifier les informations relatives au numéro de commande et saisir à nouveau.',
    },
    pt: {
        'machine-auth-modal-cancel-button': 'Iniciar um pedido de suporte',
        'machine-auth-modal-order-tital': 'Por favor, insira o número de seguimento da encomenda que deseja consultar para que possamos esclarecer a sua dúvida de forma mais rápida',
        'machine-auth-modal-ok-button': 'Iniciar um pedido de suporte sem número de seguimento',
        'machine-auth-modal-input-hint': 'Por favor, insira o número de seguimento, por exemplo, CNPRTxxxxxxx',
        'machine-auth-modal-order-type-invalid': 'O número de entrada atual está incorreto. Verifique as informações do número e tente novamente.',
    },
    he: {
        'machine-auth-modal-cancel-button': 'המשך לשאול',
        'machine-auth-modal-order-tital': 'אנא הזן את מספר ההזמנה שברצונך לברר לגביה, לעזרה מהירה',
        'machine-auth-modal-ok-button': 'אין מספר הזמנה, המשך ישירות לשאול',
        'machine-auth-modal-input-hint': 'נא להזין מספר מעקב, לדוגמא PH8000123456',
        'machine-auth-modal-order-type-invalid': 'מספר ההזמנה הנוכחי אינו נכון. נא לבדוק את פרטי מספר ההזמנה ולנסות שוב.',
    },
};
function onSuccess(info) {
    if (!redirectUrl)
        return;
    let checkSig = JSON.stringify({
        appKey,
        scene,
        mode,
        trans,
        sessionId: (info || {}).csessionid || '',
        sig: (info || {}).sig || '',
        token: window.nc_token || '',
    });
    let url = new URL(redirectUrl);
    let extraBailingConfig = {
        checkSig: checkSig,
    };
    if (url.searchParams.has('extraBailingConfig')) {
        try {
            extraBailingConfig = {
                ...JSON.parse(url.searchParams.get('extraBailingConfig')),
                ...extraBailingConfig,
            };
        }
        catch (e) {
            console.error('解析 extraBailingConfig 错误， 忽略 extraBailingConfig' +
                extraBailingConfig);
        }
    }
    url.searchParams.set('extraBailingConfig', JSON.stringify(extraBailingConfig));
    if (needOrder) {
        if (orderId && orderId.length) {
            url.searchParams.set('orderType', 'mailno');
            url.searchParams.set('orderId', orderId.trim());
        }
        else {
            url.searchParams.set('noOrder', 1);
        }
    }
    // 允许的协议
    const validProtocol = ['https:', 'http:'];
    const validHostList = [
        'cainiao.com',
        'taobao.com',
        'aliexpress.com',
        'cainiao-inc.com',
        'tmall.com',
        'cainiao.cn',
        'taobao.cn',
        'aliexpress.cn',
        'cainiao-inc.cn',
        'tmall.cn',
    ];
    if (validProtocol.includes(url.protocol) &&
        validHostList.some((v) => {
            // 全匹配
            if (v === url.host)
                return true;
            // 匹配 *.host 类型
            return url.host.endsWith('.' + v);
        })) {
        window.location.href = url.toString();
    }
    else {
        console.error('invalid url link', url.toString());
    }
}
function needOrderOnSuccess(info) {
    const langPack = langPackMap[language] || langPackMap.cn;
    function App() {
        const [oId, setOrderId] = useState(orderId);
        const [hintMessage, setHintMessage] = useState('');
        const props = {
            visible: true,
            closeMode: false,
            title: langPack['machine-auth-modal-order-tital'],
            bodyStyle: {
                minHeight: 0,
            },
            style: {
                direction: isRtl ? 'rtl' : 'unset',
            },
            children: (<div>
          <CnInput state={hintMessage ? 'error' : undefined} trim style={{ width: '100%' }} placeholder={langPack['machine-auth-modal-input-hint']} onChange={(v) => {
                    setOrderId(v);
                    orderId = v;
                    setHintMessage(undefined);
                }} defaultValue={orderId}/>
          <div style={{ color: 'red' }}>{hintMessage}</div>
        </div>),
            onOk: () => {
                if (!orderId)
                    return Promise.reject('');
                // see more: https://project.aone.alibaba-inc.com/v2/project/1129818/req/74333722
                let reg = /^([a-zA-Z]|\d)+$/gi;
                if (!reg.test(orderId.trim())) {
                    // '当前输入单号不正确，请核对单号信息后再次输入'
                    setHintMessage(langPack['machine-auth-modal-order-type-invalid']);
                    return Promise.reject('');
                }
                onSuccess(info);
            },
            onCancel: () => {
                orderId = '';
                onSuccess(info);
            },
            okProps: {
                children: langPack['machine-auth-modal-cancel-button'],
                disabled: !oId,
            },
            cancelProps: {
                children: langPack['machine-auth-modal-ok-button'],
            },
        };
        return <CnDialog {...props}/>;
    }
    try {
        window.nc && window.nc.hide();
    }
    catch (e) { }
    render(<App />, document.createElement('div'));
}
function onError() {
    console.error('人机校验失败');
}
const div = document.createElement('div');
div.id = 'nc_token';
document.body.appendChild(div);
if (window.needMachine !== false) {
    try {
        console.log('==========初始化了=========');
        window.nc_token = [appKey, new Date().getTime(), Math.random()].join(':');
        window.nc = window.NoCaptcha.init({
            renderTo: '#nc_token',
            appkey: appKey,
            scene: scene,
            token: window.nc_token,
            elementID: ['usernameID'],
            is_Opt: 0,
            language: language,
            timeout: 10000,
            retryTimes: 5,
            errorTimes: 0,
            inline: false,
            apimap: {
            // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
            // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
            },
            bannerHidden: false,
            initHidden: false,
            callback: needOrder ? needOrderOnSuccess : onSuccess,
            error: onError,
        });
        window.NoCaptcha.setEnabled(true);
        window.nc.reset(); //请务必确保这里调用一次reset()方法
        window.nc.on('fail', onError);
        window.nc.on('error', onError);
        // 初始化隐私政策
        privacyInit(language);
        try {
            if (window.NoCaptcha &&
                window.NoCaptcha.upLang &&
                typeof window.NoCaptcha.upLang === 'function') {
                window.NoCaptcha.upLang('cn', {
                    LOADING: '加载中...',
                    SLIDER_LABEL: '请向右滑动验证',
                    CHECK_Y: '验证通过',
                    ERROR_TITLE: '非常抱歉，这出错了...',
                    CHECK_N: '验证未通过',
                    OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码',
                    TIPS_TITLE: '验证码错误，请重新输入', //验证码输错时的提示
                });
                window.NoCaptcha.upLang('en', {
                    SLIDER_LABEL: 'Swipe to Agree', //等待滑动
                });
                window.NoCaptcha.upLang('ru', {
                    LOADING: 'Загрузка...',
                    SLIDER_LABEL: 'Свайп означает согласие',
                    CHECK_Y: 'Проверено',
                    ERROR_TITLE: 'К сожалению что-то пошло не так…',
                    CHECK_N: 'Проверка не удалась',
                    OVERLAY_INFORM: 'Было обнаружено, что ваша операционная система не защищена. Введите код проверки',
                    TIPS_TITLE: 'Неверный проверочный код, введите еще раз', //验证码输错时的提示
                });
                window.NoCaptcha.upLang('es', {
                    LOADING: 'Cargando...',
                    SLIDER_LABEL: 'Deslice para aceptar',
                    CHECK_Y: 'Verificación correcta ',
                    ERROR_TITLE: 'Desafortunadamente algo salió mal...',
                    CHECK_N: 'Verificación fallida',
                    OVERLAY_INFORM: 'Se ha detectado que su entorno operativo está desprotegido. Introduzca el código de verificación',
                    TIPS_TITLE: 'Código de verificación inválido, vuelva a introducirlo', //验证码输错时的提示
                });
                window.NoCaptcha.upLang('fr', {
                    LOADING: 'Chargement en cours',
                    SLIDER_LABEL: 'Glisser pour accepter',
                    CHECK_Y: 'Vérification réussie',
                    ERROR_TITLE: "Malheureusement, quelque chose s'est mal passé",
                    CHECK_N: 'Échec de la vérification ',
                    OVERLAY_INFORM: "L'environnement de votre serveur a été détecté comme n'étant pas protégé. Veuillez saisir le code de vérification.",
                    TIPS_TITLE: 'Code de vérification erroné, veuillez le saisir à nouveau', //验证码输错时的提示
                });
                window.NoCaptcha.upLang('pt', {
                    LOADING: 'Carregando',
                    SLIDER_LABEL: 'Deslizar significa concordar',
                    CHECK_Y: 'Verificação concluída',
                    ERROR_TITLE: 'Lamentamos muito, houve um erro',
                    CHECK_N: 'A verificação não foi aprovada',
                    OVERLAY_INFORM: 'Após detecção, foi identificado um risco no seu ambiente de operação atual. Por favor, insira o código de verificação',
                    TIPS_TITLE: 'Código de verificação incorreto, por favor tente novamente', //验证码输错时的提示
                });
                window.NoCaptcha.upLang('he', {
                    LOADING: 'טעינת...',
                    SLIDER_LABEL: 'החלק כדי להסכים',
                    CHECK_Y: 'אימות עבר',
                    ERROR_TITLE: 'אני מצטער מאוד, זה לא בסדר...',
                    CHECK_N: 'אימות נכשל',
                    OVERLAY_INFORM: 'לאחר גילוי כי סביבת ההפעלה הנוכחית שלך בסכנה, אנא הזן את קוד האימות.',
                    TIPS_TITLE: 'שגיאת קוד אימות, אנא הזינו מחדש', //验证码输错时的提示
                });
            }
        }
        catch (error) {
            console.log('验证组件设置语言出错', error);
        }
    }
    catch (errInfo) {
        console.log('初始化验证组件出错', errInfo);
    }
}
else {
    needOrderOnSuccess({});
}
